/**
 * Transfer ID Encoder/Decoder
 * Uses Sqids to obfuscate numeric transfer numbers in URLs for privacy.
 * e.g. "900008" ↔ "J4Tg58fR"
 */
import Sqids from 'sqids';

const sqids = new Sqids({
  alphabet: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789',
  minLength: 8,
});

/** Encode a numeric transfer number string to a URL-safe hash */
export const encodeTransferId = (transferNumber: string): string => {
  const num = parseInt(transferNumber, 10);
  if (isNaN(num)) return transferNumber; // fallback: return as-is if non-numeric
  return sqids.encode([num]);
};

/** Decode a URL hash back to the original transfer number string */
export const decodeTransferId = (hash: string): string => {
  const numbers = sqids.decode(hash);
  if (numbers.length === 0) return hash; // fallback: return as-is if decode fails
  // Restore leading zeros: encode() runs the string through parseInt(), which drops them
  // (e.g. '056575' -> 56575). ICS transfer numbers are 6-digit zero-padded, so pad back to 6.
  // 9XXXXX are already 6 digits (no-op); padStart never truncates longer numbers. (WCO-2498)
  return String(numbers[0]).padStart(6, '0');
};
